export enum WysiwygLinkType {
  Questionnaires = 'questionnaires',
  Scheduler = 'scheduler',
  GdprRemove = 'gdpr_remove',
  GdprChange = 'gdpr_change',
  GdprConsentRequest = 'gdpr_consent_request',
  External = 'external',
  IntegrationsKununuApplicantFeedback = 'integrations_kununu_applicant_feedback',
  IntegrationsKununuEmployeeFeedback = 'integrations_kununu_employee_feedback',
}

export interface WysiwygLink {
  type: WysiwygLinkType | undefined;
  url: string | undefined;
  expired?: boolean;
  id?: string;
  target?: 'blank' | 'self';
  name?: string;
  toString: () => string;
}
